import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { FeaturesConfig } from "../schemas/account";
import { Success } from "../schemas/common";

/** The word the server requires in the body before it erases anything. */
export const DELETE_CONFIRMATION = "DELETE";

/** GDPR erasure: the caller must type DELETE; the server checks it again. */
export const deleteAccount = defineApi("DeleteAccount", {
	args: { confirmation: S.String },
	response: S.Unknown,
	request: (body) => ({ method: "DELETE", path: "/account", body }),
});

export const { joinWaitlist, getFeaturesConfig } = staticApis({
	joinWaitlist: ["POST", "/waitlist", Success, { body: {} }],
	/** Public endpoint: no bearer token. */
	getFeaturesConfig: [
		"GET",
		"/config/features",
		FeaturesConfig,
		{ auth: false },
	],
});
